import { render, staticRenderFns } from "./DropdownDirective.vue?vue&type=template&id=1374d6a3&scoped=true"
import script from "./DropdownDirective.vue?vue&type=script&lang=js"
export * from "./DropdownDirective.vue?vue&type=script&lang=js"
import style0 from "./DropdownDirective.vue?vue&type=style&index=0&id=1374d6a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1374d6a3",
  null
  
)

export default component.exports